import React, {Component} from 'react';
import {Modal,Button,ButtonToolbar,FormControl,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
import SelectFormInline from '../../../component/element/SelectFormInline'
import DatePicker from '../../../component/element/DatePicker'
import HrStore from '../../../stores/HrStore'
import 'react-date-picker/index.css'
import moment from 'moment'
import DayPicker from 'react-day-picker';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
var th = require('moment/locale/th')

const LABEL = { nextMonth: '来月', previousMonth: '前月' }
const currentYear = new Date().getFullYear();
const toMonth = new Date(currentYear+1, 0, 1, 0, 0);
const fromMonth = new Date(currentYear - 20, 11, 31, 23, 59);
// Component will receive date, locale and localeUtils props
function YearMonthForm({ date, localeUtils, onChange }) {
  const months = localeUtils.getMonths('th');
  console.log('date',date)
  const years = [];
  for (let i = toMonth.getFullYear(); i >= fromMonth.getFullYear(); i -= 1) {
    years.push(i);
  }

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => <option key={i} value={i}>{month}</option>)}
      </select>
      <select name="year" onChange={handleChange} value={date.getFullYear()}>
        {years.map((year, i) => (
          <option key={i} value={year}>
            {year+543}
          </option>
        ))}
      </select>
    </form>
  );
}

function Navbar({
  nextMonth,
  previousMonth,
  onPreviousClick,
  onNextClick,
  className,
  localeUtils,
}) {
  const months = localeUtils.getMonths('th');
  const prev = months[previousMonth.getMonth()];
  const next = months[nextMonth.getMonth()];
  return (
    <div className={className} style={{ fontSize: '.75em' }}>
      <span
        style={{ float: 'left', cursor: 'pointer' }}
        onClick={() => onPreviousClick()}
      >
        ← {prev.slice(0, 3)}
      </span>
      <span
        style={{ float: 'right', cursor: 'pointer' }}
        onClick={() => onNextClick()}
      >
        {next.slice(0, 3)} →
      </span>
    </div>
  );
}
//http://react-day-picker.js.org/examples/?yearNavigation
class HolidayPopup extends Component {
  constructor(...args){
    super(...args)
    let dt = new Date();
    let year = dt.getFullYear()*1+543
    this.state = {loading:true,year:year,statusText:'',tableList:[],month:new Date(2017, 5, 23)}
    
    
  }

  loadHoliday(){
    let {year} = this.state
    let that = this
    HrStore.loadHoliday(year,function(result){

      that.setState({tableList:result.result,loading:false})
      
    },function(){

    })
  }


    onHide(){
      this.props.onHide();
    }

    getYearOptions(){
      let options = []
      var dt = new Date();
      for(let i=(dt.getFullYear()*1+543);i>=2558;i--){
        options.push({label:i,value:i})
      }
      return options;
    }

    onYearChange(e){
      let year = e.value,that = this
      that.setState({year:year,loading:true})
      HrStore.loadHoliday(year,function(result){
        that.setState({loading:false,tableList:result.result})
        window.datepicker('#box-holiday');
      },function(error){

      })
    }

    onSaveClick(){
      let {year,tableList,statusText} = this.state
      let that = this
      HrStore.saveHoliday(year,tableList,function(result){
        if(result.status==='OK'){
          that.setState({statusText:'บันทึกเรียบร้อย'})
          setTimeout(function(){ that.setState({statusText:''}) }, 3000);
        }
      },function(){

      })
    }

    onDateChange(index,dateString,dateMoment){
      console.log('e',dateString,dateMoment)
      let {tableList} = this.state
      tableList[index].display_date = dateString
      this.setState({tableList:tableList})
    }

    onRemarkChange(index,e){
      let {tableList} = this.state
      tableList[index].remark = e.target.value
      this.setState({tableList:tableList})
    }

    onAddRow(){
      let {tableList} = this.state
      tableList.push({display_date:'',remark:''})
      this.setState({tableList:tableList})
    }
// <DayPickerInput
//         labels={LABEL}
//         locale={'th'}
//         localeUtils={MomentLocaleUtils}        
//         placeholder="DD/MM/YYYY"
//         onDayChange={day => console.log(day)}
//       />
    onYearMonthChange(month){
        this.setState({ month });
    }


    renderDatePickerInput(item){
      return (
        
      <DayPicker                
          labels={LABEL}
          locale={'th'}
          localeUtils={MomentLocaleUtils}   
          month={this.state.month}
          fromMonth={fromMonth}
          toMonth={toMonth}    
          todayButton="เลือกวันนี้"      
          renderDay={day => day.getDate().toLocaleString('th')}
          captionElement={
            <YearMonthForm onChange={this.onYearMonthChange.bind(this)} />
          }  
          navbarElement={<Navbar />}        
        />
      )
    }

    renderDateField(item,index){
      //console.log('display',item.display_date)
      return (
        <DatePicker style={{display:'inline-block'}}
            showIcon={true}
            showFooter={true}
            popPlacement='bottom'
            buddhistEra
            value={item.display_date} 
            onChange={this.onDateChange.bind(this,index)}/>
      )
    }

    renderTableData(){
      let {tableList} = this.state
      return tableList.map((item,index)=>(
        <tr key={index} className="data-row">
            <td className="data-column text-center">
              {this.renderDateField(item,index)}
            </td>
            <td className="data-column">
                <FormControl value={item.remark}  onChange={this.onRemarkChange.bind(this,index)}/>
            </td>
        </tr>
      ))
    }

    renderHolidayForm(){
      let {year,loading} = this.state
      return (
        <div className="box box-default " id='box-holiday'>
            <div className="box-body">
                <div className="row">
                    <div className="navbar-form navbar-left">
                        <SelectFormInline label='ประจำปี' value={year}
                          options={this.getYearOptions()}
                          onChange={this.onYearChange.bind(this)}  clearable={false}/>
                    </div>
                </div>
                <table className="table table-responsive table-bordered-solid">
                    <thead>
                        <tr>
                            <th style={{width:'180px'}}>วันหยุด</th>
                            <th>หมายเหตุ</th>
                        </tr>
                    </thead>
                    <tbody>
                      {this.renderTableData()}
                    </tbody>

                </table>
                <Button bsStyle={null} className="btn  bg-olive " onClick={this.onAddRow.bind(this)}>+เพิ่มรายการ</Button>
            </div>
            <div className="overlay" style={{display:(loading?'block':'none')}}>
              <i className="fa fa-refresh fa-spin"></i>
            </div>
            <div className="box-footer">
                <div className=" pull-right">
                  <ButtonToolbar>
                    <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}><FontAwesome name="save"/>&nbsp;บันทึก</Button>
                    <Button bsStyle="default" onClick={this.props.onHide}><FontAwesome name="close"/>&nbsp;ปิดหน้าต่าง</Button>
                  </ButtonToolbar>
                </div>
                <div className='pull-left' style={{lineHeight:'36px'}}>
                  <ControlLabel> {this.state.statusText} </ControlLabel>
                </div>  
            </div>
                      
        </div>
      )
    }
    render(){

      let label  = 'ตั้งค่าวันหยุด'
      return (
        <Modal show={this.props.show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderHolidayForm()}
          </Modal.Body>
       </Modal>
      )
    }
}

export default HolidayPopup



// WEBPACK FOOTER //
// ./src/view/hr/slip/HolidayPopup.js